import {http} from './config';

export default {
    exists: () => {
        return http.get('api/v1/failed-jobs/existe');
    },
};
